import './standalone.scss';

import React, { useEffect, useState } from 'react';
import { PaginationListStandalone } from 'react-bootstrap-table2-paginator';

interface CustomPaginationProps {
  paginationProps: {
    page: number;
    sizePerPage: number;
    totalSize: number;
    onPageChange: (page: number) => void;
  };
}

const StandalonePagination: React.FC<CustomPaginationProps> = ({
  paginationProps,
}) => {
  const { page, totalSize, sizePerPage, onPageChange } = paginationProps;

  const totalPages = Math.ceil(totalSize / sizePerPage);
  const [inputPage, setInputPage] = useState(page);

  useEffect(() => {
    setInputPage(page);
  }, [page]);

  const handleGo = () => {
    if (inputPage >= 1 && inputPage <= totalPages) {
      onPageChange(inputPage);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleGo();
    }
  };

  return (
    <div className="standalone-pagination">
      <PaginationListStandalone {...paginationProps} />

      {totalPages > 1 && (
        <div className="standalone-pagination__jump">
          <label htmlFor="go-to-page">Go to</label>

          <input
            id="go-to-page"
            type="number"
            className="form-control"
            value={inputPage}
            onChange={(event) => setInputPage(Number(event.target.value))}
            onKeyDown={handleKeyDown}
            min={1}
            max={totalPages}
            aria-label={`Go to page, between 1 and ${totalPages}`}
          />

          <button
            type="button"
            className="btn standalone-pagination__go"
            onClick={handleGo}
          >
            Go
          </button>
        </div>
      )}
    </div>
  );
};

export default StandalonePagination;
